
const FaqData = [
    {
        question: 'Was ist LevelUp und wofür brauche ich das Tool?',
        answer: 'LevelUp ist ein neues Tool für alle Studierenden im MSM 2.0 an der Charité. Du siehst hier sämtliche Prüfungsergebnisse und deinen Lernfortschritt im Studium. Es zeigt deine MC-Prüfungsergebnisse bis ins Detail, inkl. Fragen, Antworten und Lösungen. Die praktischen ärztlichen Tätigkeiten (EPAs), die im Studium gelernt werden, werden hier dokumentiert und bewertet, sowohl durch dich selbst, als auch deine Dozierenden. Du kannst außerdem deinen Wissenszuwachs anhand des PTM-Features verfolgen. Dein Wissen wird auch nach Fachgebiet gerankt und du siehst wo aktuell deine Stärken sind, und wo du noch üben musst.'
    },
    {
        question: 'Wie nutze ich LevelUp?',
        AnswerWithLinks: ['Hier', ' geht es zum Tutorial für das Tool, und ', 'Hier', ' geht es zu einem kurzen Clickvideo, in dem gezeigt wird, wie man auf der Seite navigiert.'],
        tutorialLink: 'https://levelup.charite.de/app/tutorial/src/index.html',
        clickvideoLink: 'https://levelup.charite.de/videos/Klickvideo.mp4'
    },
    {
        question: 'Welche Daten brauche ich, um mich zu registrieren?',
        answer: 'Du brauchst nur Deine Emailadresse und Deine Matrikelnummer.'
    },
    {
        question: 'Ist LevelUp nur für Studierende im MSM 2.0?',
        answer: 'Ja, LevelUp funktioniert nur für den MSM 2.0.'
    },
    {
        question: 'Kann ich LevelUp ansehen, wenn ich nicht studiere?',
        answer: 'Leider ist die Nutzung von LevelUp nur für Studierende im MSM 2.0 möglich. Es gibt jedoch eine Demo-Version für nicht-Studierende (bzw. auch für Studierende, die noch am Beginn ihres Studiums sind und die spätere Darstellung der Prüfungsergebnisse ansehen möchten). Einfach auf der Login-Seite auf die Demo-Version gehen, oder diesen Link folgen:',
        link: 'https://levelup.charite.de/app-demo',
    },
    {
        question: 'Kann ich LevelUp vom Handy aus nutzen?',
        answer: 'Ja, LevelUp lässt sich ganz bequem  vom Handy aus nutzen. Einfach im Handy-Browser die Adresse aufrufen. LevelUp ist keine App, sondern wird im Browser dargestellt. Somit wird kein Speicherplatz für die App auf Deinem Handy benötigt.'
    },
    {
        question: 'Meine letzten Prüfungen werden nicht dargestellt, warum nicht?',
        answer: 'Die Ergebnisse der Prüfungen werden erst nach einigen Wochen in LevelUp dargestellt. Teilweise kann es leider auch einige Monate dauern, wie beim PTM. Nicht davon betroffen sind die Daten aus HIS wie Anwesenheiten und Meilensteine wie Pflegepraktikum etc. Diese werden spätestens 2 Tage nach der Darstellung in HIS auch in LevelUp angezeigt.'
    },
    {
        question: 'Eines meiner Prüfungsergebnisse stimmt nicht mit den Daten im HIS überein. Woran liegt das?',
        answer: 'Möglicherweise handelt es sich um einen Importfehler. Bitte kontaktiere in diesem Fall den Support unter',
        email: 'levelup@charite.de'
    },
    {
        question: 'Was ist TELLme?',
        answer: 'TELLme ist ein Lerntool für den MSM 2.0, mit dem du echte MC-Fragen üben kannst. Wir haben TELLme auf LevelUp verlinkt, damit du leicht zwischen deinen Prüfungsergebnissen und den Übungs-MC-Fragen navigieren kannst. Alles weitere zum TELLme-Tool findest du dort auf der Plattform. Bei Problemen mit dem Tool bitte eine Email an ',
        email: 'tellme@charite.de'
    },
    {
        question: 'Ich kann mich mit meinen Charité-Logindaten im LevelUp nicht anmelden/registrieren.',
        answer: 'Bist Du aktuell im MSM 2.0 immatrikuliert? Wenn ja,  kontaktiere den Support unter',
        email: 'levelup@charite.de'
    }

]

export default FaqData
